import React, { useRef, useEffect } from 'react'
import styles from './TestimonialSection.module.scss'
import { WithI18nProps } from '@/types/i18n'
import { createMerchantI18n, getLocaleStyleClass } from '@/utils/i18n'
import { withTranslator } from '@common/hoc/translatorHoc'



const TestimonialSection: React.FC<WithI18nProps> = ({ i18n }) => {
  const t = React.useMemo(() => createMerchantI18n(i18n), [i18n])
  const videoRefs = [useRef<HTMLVideoElement>(null), useRef<HTMLVideoElement>(null), useRef<HTMLVideoElement>(null)]

  // 组件挂载后自动播放所有视频
  useEffect(() => {
    videoRefs.forEach(videoRef => {
      const video = videoRef.current
      if (video) {
        video.play().catch(() => {})
      }
    })
  }, [])
  const  getCurrentLanguage = () => {
    if (!i18n) return 'zh-CN';
    return i18n.getLocale() || 'zh-CN';
  };

  const getCurrentLanguageClass = (style: string): string => {
    return getLocaleStyleClass(getCurrentLanguage(), style)
  }
  return (
    <section className={styles.section} >
      <div className={styles.contentWrapper}>
        <div className={`${styles.header} ${styles[getCurrentLanguageClass('header')]}`}>
          {t('accumulateGuestReviewsTitle1', "积攒游客口碑")},{t('accumulateGuestReviewsTitle2', " 赢得同行竞争")}
        </div>

        <div className={styles.grid}>
            <div className={styles.card}>
              <div className={styles.phoneWrapper}>
                <video 
                  ref={videoRefs[0]}
                  src='https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E7%B4%AF%E8%AE%A1%E8%AF%84%E4%BB%B7.mp4'
                  className={styles.phoneVideo}
                  loop
                  muted
                  playsInline
                />
              </div>
              <div className={styles.textGroup}>
                <div className={`${styles.title} ${styles[getCurrentLanguageClass('title')]}`}>{t('accumulateGuestReviews1NormalText', "累积优质")}<span className={styles.specialText}>{t('accumulateGuestReviews1SpecialText', "评价")}</span> </div>
                <div className={`${styles.desc} ${styles[getCurrentLanguageClass('desc')]}`}>{t('accumulateGuestReviews1Description', "提升用户信任，促进交易转化")}</div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.phoneWrapper}>
                <video 
                  ref={videoRefs[1]}
                  src='https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E6%98%9F%E7%BA%A7%E6%8F%90%E5%8D%87.mp4'
                  loop
                  muted
                  playsInline
                  className={styles.phoneVideo}
                />
              </div>
              <div className={styles.textGroup}>
                <div className={`${styles.title} ${styles[getCurrentLanguageClass('title')]}`}>{t('accumulateGuestReviews2NormalText1', "提升")}<span className={styles.specialText}>{t('accumulateGuestReviews2SpecialText', "星级")}</span></div>
                <div className={`${styles.desc} ${styles[getCurrentLanguageClass('desc')]}`}>{t('accumulateGuestReviews2Description', "获得推荐加权，获取更多曝光")}</div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.phoneWrapper}>
                <video 
                  ref={videoRefs[2]}
                  src='https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E6%A6%9C%E5%8D%95%E6%94%B6%E5%BD%95.mp4'
                  loop
                  muted
                  playsInline
                  className={styles.phoneVideo}
                />
              </div>
              <div className={styles.textGroup}>
                <div className={`${styles.title} ${styles[getCurrentLanguageClass('title')]}`}><span className={styles.specialText}>{t('accumulateGuestReviews3SpecialText', "榜单")}</span>{t('accumulateGuestReviews3NormalText', "收录")}</div>
                <div className={`${styles.desc} ${styles[getCurrentLanguageClass('desc')]}`}>{t('accumulateGuestReviews3Description', "榜单、活动收录，增加额外流量")}</div>
              </div>
            </div>
        </div>
      </div>
    </section>
  )
}

export default withTranslator(TestimonialSection)